<template>
  <v-container>
    <v-row justify="center" alignment="center">
      <v-col cols="12" md="8" class="text-center">
        <h1>Soft Fail</h1>
        <h3>We'll validate your receipt and will be in contact with you within 2 working days.</h3>
        <h3>IN THE MEANTIME PLEASE KEEP HOLD OF YOUR PURCHASE RECEIPT.</h3>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Timeout',
  created() {

  },
  data: () => ({
    
  }),
};
</script>
